import { ManifestProfile } from "../ManifestProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanningProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: ManifestProfile;
    panelHeader: Panel;
    sourceManifestProfile: DataSource;
}
